export const TERMS_URL = "/terms";
export const TERMS_VERSION = "v1.2";
export const TERMS_LAST_UPDATED = "November 24th, 2025";
export const PRIVACY_URL = "/privacy";
export const PRIVACY_VERSION = "v1.0";
export const PRIVACY_LAST_UPDATED = "2024-10-14";
